import { useQuery } from "@tanstack/react-query";
import ApiService from "@/api/ApiService";
import { AxiosResponse } from "axios";
import { states, transStates } from "../listView/MixingPlantView";
import { formatHistoryValue } from "./orderHistoryFormatting";
import type { HistoryValue } from "./orderHistoryFormatting";
import { OrderHistoryDialog as HistoryDialog } from "@/shared/plant/OrderHistoryDialog";
import type { OrderHistoryEntry } from "@/shared/plant/OrderHistoryDialog";

// Preserve imports from existing calendars and material editors.
// eslint-disable-next-line react-refresh/only-export-components
export { xBFormatter } from "./orderHistoryFormatting";

const formatter = (key: string, value: HistoryValue): string => {
  if (typeof value === "string" && value) {
    if (key === "plantStatus") {
      if (value === "CRITICAL") return "Kritisch"; // historical timeline entry
      return states[value as keyof typeof states]?.[2] ?? "Unbekannter Status: " + value;
    }
    if (key === "transportStatus") {
      return transStates[value as keyof typeof transStates]?.title ?? "Unbekannter Status: " + value;
    }
  }
  return formatHistoryValue(key, value);
};

export default function OrderHistoryDialog({ orderId, close }: { orderId: number | string; close: () => void }) {
  const query = useQuery<OrderHistoryEntry[], AxiosResponse>({
    queryKey: ["getOrderHistory", "" + orderId],
    enabled: !!orderId,
    queryFn: ApiService.getOrderHistory(String(orderId)),
  });
  return (
    <HistoryDialog
      open={!!orderId}
      entries={query.data ?? []}
      loading={query.isLoading || !orderId}
      error={query.isLoadingError ? "Error" : undefined}
      formatValue={formatter}
      onClose={close}
    />
  );
}
